import ReactDOM from 'react-dom'
import React from 'react';
import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: "sbw-spinner",
    template: '<div #react></div>',
    styleUrls: ["./spinner.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnInit {
    @ViewChild("react", { static: true }) react: ElementRef;

    constructor() { }

    ngOnInit() {
        this.render();
    }

    private render() {
        ReactDOM.render(
            <Spinner
            />,
            this.react.nativeElement
        );
    }
}

function Spinner() {

    return (
        <div>
            <div className="spinner-container">
                <img className="spinner" src="/_ng/booking/assets/loading.svg" />
            </div>
        </div>
    );
}

export default Spinner;
